import { defineComponent as _defineComponent } from 'vue'
import { PasswordLongevity } from '@/lib/enum/PasswordLongeviy';
import { defineMessages } from '@/lib/i18n';
import PasswordSettingTable from '@/views/pages/passwordSetting/PasswordSettingTable.vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordSettingPageDemo',
  setup(__props) {

const m = defineMessages({
  noPasswordOptionNotice:
    '「パスワードオプション」を追加購入いただいたお客様がご利用になれる機能です。お求めの場合は「お問い合わせ」からご連絡ください。',
});

/**
 * input dummy value
 */
const minimumPasswordLength = ref<number>(8);
const passwordLongevity = ref<number>(PasswordLongevity.UNLIMITED);

return { __sfc: true,m, minimumPasswordLength, passwordLongevity, PasswordSettingTable }
}

})